import { Injectable, ComponentRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CclRouteTab, CclMessageService } from "certain-common-library";
import { css_beautify } from "js-beautify";
import { HttpHeaders } from "@angular/common/http";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { processString } from "uglifycss";
import { FlashMessagesService } from "angular2-flash-messages";
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable()
export class SharedService {
    generalListLoading: boolean = false;
    unsavedData: boolean = false;
    originalData: boolean = false;
    changedData: boolean = false;
    isCreateFilter: boolean = false;
    errorStr: string;
    redirectTo: String;
    loginPopup: String;
    headers = new HttpHeaders().set("Content-Type", "application/json").set("Access-Control-Allow-Origin", "*");
    objectKeys = Object.keys;
    clearAllFilterEnabled: boolean = false;
    speakerFilterApplied: boolean = false;
    showLoader: boolean = true;
    loadingList: boolean = false;
    isUpload: boolean = false;
    setup: any;
    accountUUID: string;
    eventUUID: string;
    catalogUUID: string;
    regUUID: string;
    loginWithReUUID: boolean = false;
    catalogType: string = "SESSION";
    account: any = {};
    event: any = {};
    selectedTheme: any = {};
    sessionCustomFields: any = [];
    sessionFileCustomFields: any = [];
    sessionEnumCustomFields: any = [];
    timezone: string = "";
    speakerCustomFields: any = [];
    speakerFileCustomFields: any = [];
    speakerEnumCustomFields: any = [];
    myfav;
    mysessions;
    track;
 	type;
 	location;
 	level;
 	industry;
 	jobFunction;
 	tag;
 	customField = {};
    labelURL = './assets/i18n/en.json';
    timezonekey = 'America/Los_Angeles';
    currencySymbol= '$';
    generalPreviewRef: ComponentRef<any>;
    generalPreviewRefRender: boolean = false;
    cartViewRender: boolean = false;
    ssoList: any = { data: [] };
    regStatusesList: any = { data: [] };
    accountClientList: any;
    publishInProgress:boolean = false;
    userInfo: any;
    showMyScheduleCalendar = false;
    localTimezoneKey = moment.tz.guess(true);
    extendedValidElements: string =
        "p[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],button[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],span[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],div[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],a[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress|href|target],input[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],img[style|data|id|class|src|alt|title|hspace|vspace|width|height|align|name|onclick|onkeypress]";

    sessionDays: any = [];
    sessionTimes: any = [];
    sessionTrack: any = [];
    sessionLevels: any = [];
    sessionTypes: any = [];
    sessionLocations: any = [];
    sessionTags: any = [];
    industries: any = [];
    jobFunctions: any = [];
    productGoals: any = [];
    customFields: any = [];
    selectedDayTime = { 'day': 'All Days', 'time':'All Times'}
    selectedFilterData: any = {};
    filterName: String = '';
    filterData: any = {};
    loggedInAttendee = null;
    cartData: any = {};
    favData: any = {};
    excData: any = { size: 0, instanceId:[] };
    totalCountOfGeneralSessions = 0;
    allSessionsHidden: boolean = false;
    configs: any = {};
    createSaveFilter: boolean = false;
    generalSessionTemplate: any = '<div><strong><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.sessionTitle@}</span></strong></div><div><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.sessionDescription@}<strong>&nbsp;</strong></span></div><div><strong><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.speakerList@}</span></strong></div>'
    expandGeneralSessionTemplate: any = '<div><strong><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.sessionTitle@}</span></strong></div><div><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.sessionDescription@}</span></div><div><strong><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.speakerList@}</span></strong></div><div><span style="font-size: 10pt;  font-family: helvetica, arial, sans-serif;">{@ddf.startDateTime@}&nbsp;&ndash;&nbsp;{@ddf.endTimeHHmm@}</span></div><div><span style="font-size: 8pt;"><em><span style="font-family: helvetica, arial, sans-serif;">{@ddf.allInstances@}</span></em></span></div>'
    highlightedOrPromotedTemplate: any = '<div><span style="font-size: 12pt;"><strong><span style="font-family: helvetica, arial, sans-serif;">{@ddf.sessionTitle@}</span></strong></span></div><div><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.#speakers@}<strong>{@ddf.speakerFirstName@}&nbsp;{@ddf.speakerLastName@}</strong>,&nbsp;{@ddf.organization@}{@ddf./speakers@}</span></div><div><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.sessionDescription@}</span></div>'
    expandHighlightedOrPromotedTemplate: any = '<div><span style="font-size: 18pt;"><strong><span style="font-family: helvetica, arial, sans-serif;">{@ddf.sessionTitle@}</span></strong></span></div><div><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.#speakers@}<strong>{@ddf.speakerFirstName@}&nbsp;{@ddf.speakerLastName@}</strong>,&nbsp;{@ddf.organization@}{@ddf./speakers@}</span></div><div><span style="font-family: helvetica, arial, sans-serif; font-size: 12pt;">{@ddf.sessionDescription@}</span></div><div><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.typeName@}&nbsp;&nbsp;<strong>|</strong></span><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">&nbsp;&nbsp;{@ddf.trackName@}</span><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;"><br /></span></div>'
    resetPasswordDetails: any = {};
    preSetfilter: boolean = false;
 	preSetFilterOptions: any = {};
 	filterLabel: String = '';
    tabChangedDate: String = '';
    dates: any = [];
    dateFormat: string = 'YYYY-MM-DDTHH:mm:ss';
    filterSessionDateForBrowserTimezone = [];
    selectedSessionWidget: any = {};
    enableSessionWidgets: boolean = false;
    assetConfig: any = {
        firstGroupLabel: 'Documents',
        secondGroupLabel: 'Videos',
        thirdGroupLabel: 'Others',
        enableFirstGroup: true,
        enableSecondGroup: false,
        enableThirdGroup: false,
        firstGroupList: [],
        secondGroupList: [],
        thirdGroupList: [],
        assetSetUp: {
        header: {
            backgroundColor: "#F2F2F2",
            fontColor: "#000",
            fontStyle: 'normal',
            fontSize: 14
        },
        body: {
            backgroundColor: "#FFFFFF",
            fontColor: "#0d2958",
            fontStyle: 'normal',
            fontSize: 14
        },
        download: {
            backgroundColor: "#0d2958",
            fontColor: "#FFFFFF",
            fontStyle: 'normal',
            fontSize: 12
        },
        row: {
            backgroundColor: "#FFFFFF"
        }
        }
    }
    configTypes: any = {
        TAB_CONFIG: "TAB_CONFIG",
        FILTER_CONFIG: "FILTER_CONFIG",
        HEADER_FOOTER: {
            header: "HEADER_CONFIG",
            footer: "FOOTER_CONFIG"
        },
        SESSION: {
            general: "GENERAL_SESSION_CONFIG",
            promoted: "PROMOTED_SESSION_CONFIG",
            highlighted: "HIGHLIGHTED_SESSION_CONFIG"
        },
        DATA: {
            general: "GENERAL_DATA_SESSION_CONFIG",
            promoted: "PROMOTED_DATA_SESSION_CONFIG",
            highlighted: "HIGHLIGHTED_DATA_SESSION_CONFIG"
        },
        HTML: {
            top: "HTML_TOP",
            bottom: "HTML_BOTTOM"
        },
        SPEAKER_CONFIG: "SPEAKER_CONFIG",
        ADDITIONAL_SETTING_CONFIG: "ADDITIONAL_SETTING_CONFIG",
        MYSESSION: "MY_SESSION",
        MYSCHEDULE: "MY_SCHEDULE",
        LOGIN_POPUP: "LOGIN_POPUP",
        SESSION_RESOURCE_CONFIG: "SESSION_RESOURCE_CONFIG",
        SESSION_RECOMMENDATION_WIDGET_CONFIG: "SESSION_RECOMMENDATION_WIDGET_CONFIG"
    };
    sessionUrl = "";
    catalogLayoutConfig: any = {
        filterPlacement: "left",
        listType: "general",
        htmlElement: true
    };
    tabConfig: any = {
        isTabsEnabled: true,
        dateFormat: "EEEE, MMMM dd",
        tabData: "sessionDays",
        activeBorderColor: "",
        inactiveBorderColor: "",
        activeLabelColor: "",
        inactiveLabelColor: "",
        tabStyle: "underline",
        borderStyle: "solid",
        customCss: ".tabLabelSelected {font-family: ProximaNova-Bold; font-size: 24px;color: #000000;text-align: left;}"
    };
    filterSetup: any = {
        isFilterEnabled: true,
        styling: '.filterLabel {"background" : "#ddd"; "color" : "#000";}',
        standardFields: ["track", "sessionType", "sessionDate"],
        customFields: [],
        selectedFields: [
            { field: "track", type: "standardFields" },
            { field: "sessionType", type: "standardFields" },
            { field: "sessionDate", type: "standardFields" }
        ],
        expansionStyles: 1,
        selectionMechanism: 1,
        label: "Filter",
        header: {
            backgroundColor: "",
            fontStyle: "",
            fontSize: "",
            fontColor: ""
        },
        body: {
            backgroundColor: "",
            fontStyle: "",
            fontSize: "",
            fontColor: ""
        }
    };
    tabsConfig: any = {};
    expansionStyle: string;
    customTheme: any;
    addEventtoCalendarConfig: any = {
        template: `<div><strong><span style="font-family: helvetica, arial, sans-serif; font-size: 10pt;">{@ddf.sessionTitle@}</span></strong></div>
        	    <div><span style="font-size: 10pt; font-family: helvetica, arial, sans-serif;">{@ddf.sessionDescription@}<strong>&nbsp;</strong></span></div>`
        }
    speakerLayoutConfig: any = {
        layout: "l_square",
        labelConfig: {
            label: "Speaker Information",
            fontColor: "#737373",
            fontStyle: "bold",
            fontSize: "12"
        },
        catalogConfig: {
            body: {
                regionConfig: {
                    margin: "5px",
                    padding: "5px",
                    background: "#FBFBFB",
                    corner: "10px"
                },
                textConfig: {
                    background: "#FBFBFB",
                    textColor: "#000000",
                    template:
                        "<div><strong><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.firstName'>{@ddf.firstName@}</span>&nbsp;<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.lastName'>{@ddf.lastName@}</span>, <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.position'>{@ddf.position@}</span></strong>,<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.organization'>{@ddf.organization@}</span></div><div><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.biography'>{@ddf.biography@}</span></div><div><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionList'>{@ddf.sessionList@}</span></div>"
                },
                imageConfig: {
                    basedOn: "speaker_img",
                    height: "160px",
                    width: "160px",
                    margin: "5px"
                }
            }
        }
    };
    sessionLayoutConfig: any = {
        highlighted: {
            layout: "l_noimage",
            labelConfig: {
                label: "Highlighted Sessions",
                fontColor: "#737373",
                fontStyle: "bold",
                fontSize: "22"
            },
            catalogConfig: {
                header: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 28px; font-family: sans-serif;'><strong><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></strong></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 24px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span></div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                },
                body: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 28px; font-family: sans-serif;'><strong><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></strong></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 24px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span>&nbsp;</div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Track :</strong> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.trackName'>{@ddf.trackName@}</span>&nbsp;</div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 14px; font-family: sans-serif;'><strong>Speakers</strong></div><div style='font-size: 14px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerFirstName'>{@ddf.speakerFirstName@}</span>&nbsp;<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerLastName'>{@ddf.speakerLastName@}</span>&nbsp;{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.organization'>{@ddf.organization@}</span> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.position'>{@ddf.position@}</span>{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 10px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='false' data-original-variable='ddf.allInstances'>{@ddf.allInstances@}</span>&nbsp;</div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                }
            }
        },
        promoted: {
            layout: "l_noimage",
            labelConfig: {
                label: "Promoted Sessions",
                fontColor: "#737373",
                fontStyle: "bold",
                fontSize: "22"
            },
            catalogConfig: {
                header: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 28px; font-family: sans-serif;'><strong><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></strong></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 24px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span></div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                },
                body: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 28px; font-family: sans-serif;'><strong><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></strong></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 24px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span>&nbsp;</div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Track :</strong> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.trackName'>{@ddf.trackName@}</span>&nbsp;</div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 14px; font-family: sans-serif;'><strong>Speakers</strong></div><div style='font-size: 14px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerFirstName'>{@ddf.speakerFirstName@}</span>&nbsp;<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerLastName'>{@ddf.speakerLastName@}</span>&nbsp;{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.organization'>{@ddf.organization@}</span> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.position'>{@ddf.position@}</span>{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 10px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='false' data-original-variable='ddf.allInstances'>{@ddf.allInstances@}</span>&nbsp;</div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                }
            }
        },
        general: {
            layout: "l_noimage",
            labelConfig: {
                label: "General Sessions",
                fontColor: "#737373",
                fontStyle: "bold",
                fontSize: "22"
            },
            catalogConfig: {
                header: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 22px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 14px; font-family: sans-serif;'><strong>Speakers</strong></div><div style='font-size: 14px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerFirstName'>{@ddf.speakerFirstName@}</span><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerLastName'>{@ddf.speakerLastName@}</span>,{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.organization'>{@ddf.organization@}</span><span style='color: #999999;'>&nbsp;</span><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.position'>{@ddf.position@}</span>{@ddf./speakers@}</div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                },
                body: {
                    regionConfig: {
                        margin: "5px",
                        padding: "5px",
                        background: "#FBFBFB",
                        corner: "10px"
                    },
                    textConfig: {
                        background: "#FBFBFB",
                        textColor: "#000000",
                        template:
                            "<div style='font-size: 22px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.abstractDesc'>{@ddf.abstractDesc@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Track :</strong> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.trackName'>{@ddf.trackName@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Code : <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.occurrenceCode'>{@ddf.occurrenceCode@}</span></strong></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Schedule :</strong> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.startDateTime'>{@ddf.startDateTime@}</span>&nbsp;-&nbsp; <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.endTimeHHmm'>{@ddf.endTimeHHmm@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 18px; font-family: sans-serif;'><strong>Location :</strong> <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.locationName'>{@ddf.locationName@}</span></div><div style='font-size: 3px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 14px; font-family: sans-serif;'><strong>Speakers</strong></div><div style='font-size: 14px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerFirstName'>{@ddf.speakerFirstName@}</span>&nbsp;<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.speakerLastName'>{@ddf.speakerLastName@}</span>{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>{@ddf.#speakers@}<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.organization'>{@ddf.organization@}</span>&nbsp;<span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.position'>{@ddf.position@}</span>{@ddf./speakers@}</div><div style='font-size: 10px; font-family: sans-serif;'>&nbsp;</div><div style='font-size: 10px; font-family: sans-serif;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.allInstances'>{@ddf.allInstances@}</span></div>"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        width: "160px",
                        margin: "5px"
                    }
                },
                buttonConfig: {
                    favIcon: "fa-heart",
                    favIconSec: "fa-heart-o",
                    favIconColor: "#333333",
                    favIconSize: "20",
                    regLabel: "Registered",
                    regColor: "#ffffff",
                    regBackground: "#2fb36d",
                    regFontSize: "10",
                    regFontStyle: "bold",
                    waitLabel: "Waitlisted",
                    waitColor: "#ffffff",
                    waitBackground: "#FA8A3B",
                    waitFontSize: "10",
                    waitFontStyle: "bold",
                    cartIcon: "fa-cart-arrow-down",
                    cartIconSec: "fa-cart-arrow-down",
                    cartIconColor: "#333333",
                    cartIconSize: "20",
                    excIcon: "fa-eye-slash",
                    excIconSec: "fa-eye-slash",
                    excIconColor: "#888888",
                    excIconSize: "20",
                    cartButtonLabel: "Add to Cart",
                    cartButtonBackground: "#186DF2",
                    cartButtonColor: "#ffffff",
                    cartButtonStyle: "bold",
                    cartButtonSize: "18",
                    removeScheduleButtonLabel: "Cancel",
                    removeScheduleButtonBackground: "#ffffff",
                    removeScheduleButtonColor: "#000000",
                    removeScheduleButtonStyle: "bold",
                    enableAddToCartButton: true
                }
            }
        },
        mysession: {
            isSessionEnabled: true,
            drawer_button: {
                icon: "fa-cart-arrow-down",
                color: "#FBFBFB",
                background: "#0d2958"
            },
            header: {
                label: "My Sessions",
                label_color: "#FBFBFB",
                icon_color: "#FFFFFF",
                background: "#0d2958"
            },
            tabConfig: {
                activeBorderColor: "#0d2958",
                inactiveBorderColor: "#FFFFFF",
                activeLabelColor: "#000000",
                inactiveLabelColor: "#000000",
                tabStyle: "underline",
                borderStyle: "solid"
            },
            button: {
                primary: {
                    background: "#0d2958",
                    color: "#FBFBFB"
                },
                secondary: {
                    background: "#FBFBFB",
                    color: "#0d2958"
                }
            },
            catalogConfig: {
                header: {
                    regionConfig: {
                        background: "#FBFBFB",
                        corner: "10px",
                        margin: "5px",
                        padding: "5px"
                    },
                    textConfig: {
                        background: "#FFFFFF",
                        template:
                            "<div><strong><span style='font-size: 16pt;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.sessionTitle'>{@ddf.sessionTitle@}</span>&nbsp;- <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.occurrenceCode'>{@ddf.occurrenceCode@}</span></span></strong></div><div><span style='font-size: 11pt;'><span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.startDateTime'>{@ddf.startDateTime@}</span>&nbsp;- <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.endTimeHHmm'>{@ddf.endTimeHHmm@}</span>&nbsp;| <span class='c-tinymce-variable' contenteditable='true' data-original-variable='ddf.locationName'>{@ddf.locationName@}</span></span></div>",
                        textColor: "#000000"
                    },
                    imageConfig: {
                        basedOn: "speaker_img",
                        height: "160px",
                        margin: "5px",
                        width: "160px"
                    }
                }
            }
        },
        myschedule: {
            isScheduledEnabled: true,
            my_schedule_drawer_button: {
                icon: "fa-calendar",
                color: "#FBFBFB",
                background: "#0d2958"
            },
            my_schedule_header: {
                label: "My Schedule",
                label_color: "#FBFBFB",
                icon_color: "#FFFFFF",
                background: "#0d2958",
                fontStyle: "normal"
            },
            calenderConfig:{
                showLocation:true,
                showSpeakers:false
            }
        },
        sessionresources: {
            isResourceEnabled: false,
            header: {
                label: "Session Resources",
                label_color: "#FBFBFB",
                icon_color: "#FFFFFF",
                background: "#0d2958"
            },
            button: {
                primary: {
                    background: "#0d2958",
                    color: "#FBFBFB"
                },
                secondary: {
                    background: "#FBFBFB",
                    color: "#0d2958"
                }
            }
        },
        sessionrecommendationwidgets: {
            isWidgetEnabled: false,
            widget: {
                uuid:"",
                applyCatalogConfiguration: false
            }
        }
    };
    dataConfig: any = {
        highlighted: {
            displayAs: "all_session",
            selectedList: []
        },
        promoted: {
            displayAs: "all_session",
            selectedList: []
        },
        general: {
            topLevel: {
                sortingBy: "",
                active: true,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            secondLevel: {
                sortingBy: "",
                active: false,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            thirdLevel: {
                sortingBy: "",
                active: false,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            dateTimeFormats: {
                dateFormat: "EEEE, MMMM dd",
                timeFormat: "hh:mm a"
            }
        }
    };
    loginConfig: any = {
        isEnabled: true,
        header: {
            label: "Login",
            label_color: "#FBFBFB",
            background: "#0d2958"
        },
        body: {
            background: "#FBFBFB",
            help_text: "Log-in with the credentials you used to Register.",
            loginOption: "username",
            username: "Username",
            password: "Password",
            isSSOEnabled: false,
            ssoConfigs: [],
            regStatusConfigs: [],
            changeRegStatusConfigs: [],
            changeRegStatus: "Registration Status"
        },
        footer: {
            background: "#FBFBFB",
            help_text: "If you haven’t registered, you can do so here.",
            button: {
                primary: {
                    label: "Log-in",
                    background: "#0d2958",
                    color: "#FBFBFB"
                },
                secondary: {
                    label: "Sign-up",
                    background: "#FBFBFB",
                    color: "#0d2958"
                }
            }
        },
        sessionExpiredConfig: {
            header: {
                label: "User Session Expired",
                label_color: "#FBFBFB",
                background: "#0d2958",
                fontStyle: "normal"
            },
            body: {
                background: "#FBFBFB",
                text: "<div><p>Your session has expired due to inactivity.</p><p>Please log in again to continue <strong>OR</strong> follow these steps:</p><ol><li>Open your invitation email</li><li>Click the access link</li></ol></div>"
            },
            footer: {
                background: "#FBFBFB",
                button: {
                    primary: {
                        isPrimaryEnabled: true,
                        label: "Go to Login",
                        background: "#0d2958",
                        color: "#FBFBFB"
                    }
                }
            }
        }
    };

    // SCM-52036 :Session Catalog _ pre-filter changes moved to backlog
    // loginConfig: any = {
    //     isEnabled: true,
    //     header: {
    //         label: "Login",
    //         label_color: "#FBFBFB",
    //         background: "#0d2958"
    //     },
    //     body: {
    //         background: "#FBFBFB",
    //         help_text: "Log-in with the credentials you used to Register.",
    //         loginOption: "username",
    //         username: "Username",
    //         password: "Password",
    //         isSSOEnabled: false,
    //         ssoConfigs: [],
    //         regStatusConfigs: [],
    //         changeRegStatusConfigs: [],
    //         changeRegStatus: "Registration Status",
    //         showAfterLoginPreFilter: false,
    //         preFilterConfigs: [],
    //         preFilterConfig: "Pre-filter"
    //     },
    //     footer: {
    //         background: "#FBFBFB",
    //         help_text: "If you haven’t registered, you can do so here.",
    //         button: {
    //             primary: {
    //                 label: "Log-in",
    //                 background: "#0d2958",
    //                 color: "#FBFBFB"
    //             },
    //             secondary: {
    //                 label: "Sign-up",
    //                 background: "#FBFBFB",
    //                 color: "#0d2958"
    //             }
    //         }
    //     }
    // };

    currentLayoutSection: String;
    private _currentDrawer: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    } = <any>{};
    private _currentPopup: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    } = <any>{};
    tracks: any;
    types: any;
    tags: any;
    levels: any;
    attendeeTypes: any;
    isEditSaveFilter: boolean = false;
 	editSaveFilter: any = {};
    dateFormats: any = [
        {
            label: "Friday, March 14",
            format: "EEEE, MMMM dd",
            javaFormat: "EEEE, MMMM dd"
        },
        {
            label: "Friday, 3/14",
            format: "EEEE, M/dd",
            javaFormat: "EEEE, M/dd"
        },
        {
            label: "Friday, March 14 2019",
            format: "EEEE, MMMM dd yyyy",
            javaFormat: "EEEE, MMMM dd yyyy"
        },
        {
            label: "Fri, Mar 14 2019",
            format: "EEE, MMM dd yyyy",
            javaFormat: "E, MMM dd yyyy"
        }
    ];

    timeFormats: any = [
        {
            label: "04:30 PM",
            format: "hh:mm a",
            javaFormat: "hh:mm a"
        },
        {
            label: "4:30 PM",
            format: "h:mm a",
            javaFormat: "h:mm a"
        },
        {
            label: "16:30",
            format: "HH:mm",
            javaFormat: "HH:mm"
        },
        {
            label: "4:30/16:30",
            format: "H:mm",
            javaFormat: "H:mm"
        }
    ];
    fontStyles: any = [
        {
            id: "normal",
            label: "Normal"
        },
        {
            id: "bold",
            label: "Bold"
        },
        {
            id: "italic",
            label: "Italic"
        },
        {
            id: "underline",
            label: "Underline"
        }
    ];
    loginOptions: any = [
        {
            id: "username",
            label: "Username"
        },
        {
            id: "email",
            label: "Email"
        }
    ];
    fontSizes: any = this.getRanngeArray(12, 40, 2);
    fontSizesSmall: any = this.getRanngeArray(12, 22, 2);

    renderViewSubject: Subject<boolean> = new Subject<boolean>();
    selectedDates: any = null;
    
    allowedPreFiltersList: any = [
        {
            "id":0,
            "name":"Date",
            "orderIndex":1
        },
        {
            "id":1,
            "name":"Type",
            "orderIndex":2
        },
        {
            "id":2,
            "name":"Track",
            "orderIndex":3
        },
        {
            "id":3,
            "name":"Tags",
            "orderIndex":4
        }
    ];

    constructor(
        private translate: TranslateService,
        private router: Router,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService
    ) {
        this.currentLayoutSection = "header";
    }
    renderView() {
        this.renderViewSubject.next(this.generalPreviewRefRender);
        this.loadingList = false;
    }

    renderCartViewSubject: Subject<boolean> = new Subject<boolean>();
    renderCartView() {
        this.renderCartViewSubject.next(this.cartViewRender);
    }

    public copyText(val: string) {
        let selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
    }

    public get currentDrawer(): {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    } {
        return this._currentDrawer;
    }
    public set currentDrawer(value: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    }) {
        value.saveLabel = value.saveLabel != null ? value.saveLabel : "Apply";
        value.cancelLabel = value.cancelLabel != null ? value.cancelLabel : "Close";
        value.doneLabel = value.doneLabel != null ? value.doneLabel : "Done";
        this._currentDrawer = value;
    }

    public get currentPopup(): {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    } {
        return this._currentPopup;
    }
    public set currentPopup(value: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    }) {
        this._currentPopup = value;
    }
    public beautifyCSS(css) {
        if (css != null) {
            return css_beautify(css, {
                indent_size: 5
            });
        } else {
            return "";
        }
    }
    public getParameterByName(name: string) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results == null || results.length <= 0 ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    public unsubscribeHelper(subscription: Subscription) {
        if (subscription != null) {
            subscription.unsubscribe();
        }
    }

    public catalogNavigateHelper(urlPrefix: string, urlPortion: string) {
        if (!urlPrefix.endsWith("/")) {
            urlPrefix = urlPrefix + "/";
        }
        if (!urlPortion.startsWith("/")) {
            urlPortion = "/" + urlPortion;
        }
        this.navigateHelper(urlPrefix + this.catalogUUID + urlPortion);
    }

    public navigateHelper(url: string) {
        this.router.navigate([url]);
    }

    public navigateToOutlet(outlet: string, url: string) {
        if (outlet == "drawer") {
            this.router.navigate([{ outlets: { drawer: url } }]);
        } else if (outlet == "popup") {
            this.router.navigate([{ outlets: { popup: url } }], { queryParamsHandling: "merge" });
        }
    }

    public getDateFormatArray(date) {
        var dt = new Date(date);
        return dt;
    }

    public getDateArray(start, end) {
        var arr = new Array();
        if (start != null && end != null) {
            var dt = new Date(start);
            while (dt <= end) {
                arr.push(new Date(dt));
                dt.setDate(dt.getDate() + 1);
            }
        }
        return arr;
    }

    public getRanngeArray(start, end, offset) {
        var arr = new Array();
        if (start != null && end != null) {
            while (start <= end) {
                arr.push(start);
                start = start + (offset ? offset : 1);
            }
        }
        return arr;
    }
    public toCamelCase(str) {
        return str.replace(/^(.)/g, function($1) {
            return $1.toUpperCase();
        });
    }

    public isEmptyString(str) {
        return str == null || str == "undefined" || str == "null" || str.trim().length == 0;
    }

    public encodeId = function(id) {
        var slope = 19;
        var intercept = 267;
        return id * slope + intercept;
    };

    public timezoneSort(timezoneArray) {
        timezoneArray.sort( function( a, b ) {
            var aOffset = parseInt(a.offset);
            var bOffset = parseInt(b.offset);
            return aOffset < bOffset ? -1 : aOffset > bOffset ? 1 : 0;
        });
        return timezoneArray;
    }

    public isMSIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return false
        {
            return false;
        }
    }

    public showErrorMsg(err: any) {
        var message = "";
        if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
            err.error.errorResponse.errors.forEach((element) => {
                if (element == "Deleted Registration.") {
                    this.messageService.sendMessage("close-cart-if-open");
                    this.messageService.sendMessage("close-myschedule-if-open");
                    this.messageService.sendMessage("attendee-deleted");
                    message += "Invalid session, logging out." + "\n";
                    this._flashMessagesService.show(message, {
                        cssClass: "alert-danger"
                    });
                }
            });
        }
    }

    private createLabelGeneralData(config, className) {
        let cssString =
            `.general-data-${className}-text{ ` +
            `background-color: ${config[`${className}`].textConfig.backgroundColor};` +
            `font-style: ${config[`${className}`].textConfig.fontStyle};` +
            `text-decoration: ${config[`${className}`].textConfig.fontStyle};` +
            `font-weight: ${config[`${className}`].textConfig.fontStyle};` +
            `font-size: ${config[`${className}`].textConfig.fontSize}px;` +
            `color: ${config[`${className}`].textConfig.fontColor};` +
            "}";
        return cssString;
    }

    public createCssGeneralData({ config }) {
        let cssString = "";
        config = JSON.parse(config);

        cssString = cssString.concat(this.createLabelGeneralData(config, "topLevel"));
        cssString = cssString.concat(this.createLabelGeneralData(config, "secondLevel"));
        cssString = cssString.concat(this.createLabelGeneralData(config, "thirdLevel"));

        return cssString;
    }

    public updateCss() {
        var cssPath =
            `/accounts/${this.event.fileDir}session_catalog_${this.catalogUUID}.css` +
            "?random=" +
            new Date().getTime();
        $("#stylesheet").empty();
        $("#stylesheet").prepend(`<link rel="stylesheet" type="text/css" href="${cssPath}" />`);
    }

    public updateDateTime(sessions, selectTimezone, type='') {
        if(this.timezone && selectTimezone == 'browser_timezone') {
            sessions.forEach((element) => {
                if(element.startTime && element.startTime != null) {
                    if(type == 'generalList') {
                        element.evtstartTime = moment(element.startTime).tz(this.localTimezoneKey).format('YYYY-MM-DD HH:mm:00');
                    }
                    element.startTime = moment(element.startTime).tz(this.timezone).format('YYYY-MM-DD HH:mm:00');
                }
                if(element.endTime && element.endTime != null) {
                    if(type == 'generalList') {
                        element.evtendTime = moment(element.endTime).tz(this.localTimezoneKey).format('YYYY-MM-DD HH:mm:00');
                    }
                    element.endTime = moment(element.endTime).tz(this.timezone).format('YYYY-MM-DD HH:mm:00'); 
                }
            })
        }
    }

    updateJson(catalogService) {
        let jsonPath =
            `/accounts/${this.event.fileDir}session_catalog_${this.catalogUUID}.json` +
            "?random=" +
            new Date().getTime();
        catalogService.getJSONService(jsonPath).subscribe((data)=> {
            if(data.body) {
                this.labelURL = jsonPath;
                this.translate.use(this.labelURL);
            }
        },(error) => {
            this.translate.use(this.labelURL);
        })  
    }

    public createCss(catalogService) {
        let cssString = "";
        cssString = cssString.concat(this.createCssLoginPopup(this.configs[`${this.configTypes.LOGIN_POPUP}`]));
        cssString = cssString.concat(this.createCssTabs(this.configs[`${this.configTypes.TAB_CONFIG}`]));
        cssString = cssString.concat(this.createCssMySession(this.configs[`${this.configTypes.MYSESSION}`]));
        cssString = cssString.concat(this.createCssFilter(this.configs[`${this.configTypes.FILTER_CONFIG}`]));
        cssString = cssString.concat(this.createCssSessions(this.configs[`${this.configTypes.SESSION.general}`]));
        cssString = cssString.concat(this.createCssSessions(this.configs[`${this.configTypes.SESSION.highlighted}`]));
        cssString = cssString.concat(this.createCssSessions(this.configs[`${this.configTypes.SESSION.promoted}`]));
        cssString = cssString.concat(this.createCssSpeaker(this.configs[`${this.configTypes.SPEAKER_CONFIG}`]));
        cssString = cssString.concat(this.createCssGeneralSession(this.configs[`${this.configTypes.SESSION.general}`]));
        cssString = cssString.concat(this.createCssGeneralData(this.configs[`${this.configTypes.DATA.general}`]));
        //     cssString = processString(cssString); // minifies the css string .commented here becoz not working in IE
        const cssBlob = new Blob([cssString], { type: "text/plain" });
        const formData: FormData = new FormData();
        formData.append("file", cssBlob, `session_catalog_${this.catalogUUID}.css`);
        catalogService.saveCss(formData).subscribe(() => {
            this.updateCss();
        });
    }

    // private createPreviewCss() {
    //     let cssString = "";
    //     console.log(this.selectedThem);
    // }

    private createCssSessions({ config, configType }): string {
        config = JSON.parse(config);
        let cssString = "";
        let classPrefix = configType
            .toLowerCase()
            .replace(/_/g, "-")
            .replace("-config", "");
        
            if(config.catalogConfig.body.assetConfig) {
                // Asset Group header
                cssString = cssString.concat(
                    `.${classPrefix}-group-header {`,
                    `background: ${config.catalogConfig.body.assetConfig.assetSetUp.header.backgroundColor};`,
                    `color: ${config.catalogConfig.body.assetConfig.assetSetUp.header.fontColor};`,
                    `font-style: ${config.catalogConfig.body.assetConfig.assetSetUp.header.fontStyle};`,
                    `text-decoration: ${config.catalogConfig.body.assetConfig.assetSetUp.header.fontStyle};`,
                    `font-weight: ${config.catalogConfig.body.assetConfig.assetSetUp.header.fontStyle};`,
                    `font-size: ${config.catalogConfig.body.assetConfig.assetSetUp.header.fontSize}px;`,
                    `font-family: helvetica, arial, sans-serif;`,
                    `float: left;`,
                    `margin-bottom: 0;`,
                   "}"
                );
                	
                // Asset Document Name
                cssString = cssString.concat(
                    `.${classPrefix}-document-label {`,
                    `background: ${config.catalogConfig.body.assetConfig.assetSetUp.body.backgroundColor};`,
    	            `color: ${config.catalogConfig.body.assetConfig.assetSetUp.body.fontColor};`,
                    `font-style: ${config.catalogConfig.body.assetConfig.assetSetUp.body.fontStyle};`,
                    `text-decoration: ${config.catalogConfig.body.assetConfig.assetSetUp.body.fontStyle};`,
                    `font-weight: ${config.catalogConfig.body.assetConfig.assetSetUp.body.fontStyle};`,
                    `font-size: ${config.catalogConfig.body.assetConfig.assetSetUp.body.fontSize}px;`,
                    "}"
                );
                	
                // Asset download button
                cssString = cssString.concat(
                    `.${classPrefix}-download-btn {`,
                    `background: ${config.catalogConfig.body.assetConfig.assetSetUp.download.backgroundColor};`,
                    `color: ${config.catalogConfig.body.assetConfig.assetSetUp.download.fontColor};`,
                    `font-style: ${config.catalogConfig.body.assetConfig.assetSetUp.download.fontStyle};`,
                    `text-decoration: ${config.catalogConfig.body.assetConfig.assetSetUp.download.fontStyle};`,
                    `font-weight: ${config.catalogConfig.body.assetConfig.assetSetUp.download.fontStyle};`,
                    `font-size: ${config.catalogConfig.body.assetConfig.assetSetUp.download.fontSize}px;`,
                    `border-radius: 12px;`,
                    `padding: 0 22px 0px 22px;`,
                    `width: 150px;`,
                    "}"
                );
                	
                // Asset row 
                cssString = cssString.concat(
                    `.${classPrefix}-asset-row {`,
                    `background: ${config.catalogConfig.body.assetConfig.assetSetUp.row.backgroundColor};`,
                    `padding: 10px;`,
                    `margin: 4px;`,
                    `border-radius: 13px;`,
                    `height: 50px;`,
                    "}"
                    );
            }

        // label
        cssString = cssString.concat(
            `.${classPrefix}-label {`,
            `color: ${config.labelConfig.fontColor};`,
            `font-style: ${config.labelConfig.fontStyle};`,
            `text-decoration: ${config.labelConfig.fontStyle};`,
            `font-weight: ${config.labelConfig.fontStyle};`,
            `font-size: ${config.labelConfig.fontSize}px;`,
            "}"
        );

        //Adding headerTextStyleStr
        cssString = cssString.concat(
            `.${classPrefix}-header-text-style { `,
            `background: ${config.catalogConfig.header.textConfig.background}; `,
            `color: ${config.catalogConfig.header.textConfig.textColor}; `,
            "} ",
            `.${classPrefix}-header-text-style-image-no-banner-no-card { `,
            `width: calc(98% - ${config.catalogConfig.header.imageConfig.width}); `,
            "} ",
            `.${classPrefix}-header-text-style-no-image-or-banner-or-card { `,
            `width: 99%; `,
            "} "
        );

        //TextStyleStr
        cssString = cssString.concat(this.createTextStyleStr(config, classPrefix, "header"));
        cssString = cssString.concat(this.createTextStyleStr(config, classPrefix, "body"));

        // styleStr
        cssString = cssString.concat(this.createStyleStr(config, classPrefix, "header"));
        cssString = cssString.concat(this.createStyleStr(config, classPrefix, "body"));

        // imageStyle
        cssString = cssString.concat(this.createImageCss(config, classPrefix, "header"));
        cssString = cssString.concat(this.createImageCss(config, classPrefix, "body"));

        return cssString;
    }

    private createCssGeneralSession({ config }): string {
        config = JSON.parse(config);
        let cssString = "";
        let padding = config.catalogConfig.header.regionConfig.padding;
        let top = "-10px";
        let right = "-10px";
        if (padding != null) {
            let paddings = padding.split(" ");
            if (paddings.length == 1) {
                top = "-" + paddings[0];
                right = "-" + paddings[0];
            } else if (paddings.length == 2 || paddings.length == 4) {
                top = "-" + paddings[0];
                right = "-" + paddings[1];
            }
        }

        cssString = cssString.concat(
            `.general-session-catalog-header-region-background-1-4 {`,
            `background: ${config.catalogConfig.buttonConfig.regBackground};`,
            "}"
        );

        // cart processed confirmation popup reg icon
        cssString = cssString.concat(
            ".panel-reg-icon {",
            `color: ${config.catalogConfig.buttonConfig.regBackground};`,
            "padding-right: 5px;}"
        );

        cssString = cssString.concat(
            `.general-session-catalog-header-region-background-2-3 {`,
            "background: #9B9B9B;",
            "}"
        );

        

        // buttonconfig
        cssString = cssString.concat(
            ".general-session-catalog-button-fav-icon {",
            `font-size: ${config.catalogConfig.buttonConfig.favIconSize}px;`,
            `color: ${config.catalogConfig.buttonConfig.favIconColor};`,
            "}"
        );

        cssString = cssString.concat(
            ".instance-action-icon {",
            `color: ${config.catalogConfig.buttonConfig.favIconColor};`,
            "}"
        );

        cssString = cssString.concat(
            ".general-session-catalog-button-exclude-icon {",
            `font-size: ${config.catalogConfig.buttonConfig.excIconSize}px;`,
            `color: ${config.catalogConfig.buttonConfig.excIconColor};`,
            "}"
        );

        cssString = cssString.concat(
            ".general-session-catalog-button-cart-icon {",
            `font-size: ${config.catalogConfig.buttonConfig.cartIconSize}px;`,
            `color: ${config.catalogConfig.buttonConfig.cartIconColor};`,
            "}"
        );

        cssString = cssString.concat(
            ".general-session-catalog-add-cart-btn {",
            "float: right;",
            `background: ${config.catalogConfig.buttonConfig.cartButtonBackground};`,
            "padding: 8px;",
            "border-radius: 15px 0px 0px 0px;",
            "font-size: 18px;",
            `color: ${config.catalogConfig.buttonConfig.cartButtonColor};`,
            `text-decoration: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            `font-weight: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            `font-style: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            "}"
        );

        cssString = cssString.concat(
            ".general-session-catalog-add-calendar-btn {",
            `background: ${config.catalogConfig.buttonConfig.calendarButtonBackground};`,
            "padding: 8px;",
            "font-size: 18px;",
            `color: ${config.catalogConfig.buttonConfig.calendarButtonColor} !important;`,
            `text-decoration: ${config.catalogConfig.buttonConfig.calendarButtonStyle};`,
            `font-weight: ${config.catalogConfig.buttonConfig.calendarButtonStyle};`,
            `font-style: ${config.catalogConfig.buttonConfig.calendarButtonStyle};`,
            `padding-left: 45px;`,
            "}"
        );
        
        cssString = cssString.concat(
            ".addeventatc:hover {",
            `background: ${config.catalogConfig.buttonConfig.calendarButtonBackground};`,
            "font-size: 18px;",
            `color: ${config.catalogConfig.buttonConfig.calendarButtonColor};`,
            `text-decoration: ${config.catalogConfig.buttonConfig.calendarButtonStyle};`,
            "}"
        );

        cssString = cssString.concat(
            ".general-session-catalog-add-schedule-btn {",
            "float: right;",
            `background: ${config.catalogConfig.buttonConfig.cartButtonBackground};`,
            "padding: 8px;",
            "border-radius: 15px 0px 0px 0px;",
            "font-size: 20px;",
            `color: ${config.catalogConfig.buttonConfig.cartButtonColor};`,
            `text-decoration: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            `font-weight: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            `font-style: ${config.catalogConfig.buttonConfig.cartButtonStyle};`,
            "}"
        );

        if(this.catalogLayoutConfig.generalStyle && this.catalogLayoutConfig.generalStyle == 'card') {
            cssString = cssString.concat(
                ".general-session-catalog-remove-schedule-btn {",
                `background: ${config.catalogConfig.buttonConfig.removeScheduleButtonBackground};`,
                "padding: 3px;",
                "font-size: 18px;",
                `color: ${config.catalogConfig.buttonConfig.removeScheduleButtonColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                "}"
            );

            cssString = cssString.concat(
                ".capacity-full-card {",
                "text-align: right;",
                "font-size: 15px;",
                `color: ${config.catalogConfig.buttonConfig.capacityFullColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                "margin-top: 29px;",
                "}"
            );


            cssString = cssString.concat(
                `.general-session-catalog-header-region-label {`,
                "position: absolute;",
                `border: 10px solid ${config.catalogConfig.header.regionConfig.background};`,
                "border-radius: 20px;",
                "top: -12px;",
                `right: ${right};`,
                "cursor: default;",
                "float: right;",
                "padding: 4px 14px;",
                `font-size: ${config.catalogConfig.buttonConfig.regFontSize}px;`,
                `color: ${config.catalogConfig.buttonConfig.regColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                "}"
            );

            cssString = cssString.concat(
                `.general-session-catalog-button-registered {`,
                `background: ${config.catalogConfig.buttonConfig.regBackground};`,
                "border-radius: 20px;",
                "padding: 4px 14px;",
                `font-size: 10px;`,
                `color: ${config.catalogConfig.buttonConfig.regColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                "}"
            );

        } else {
            cssString = cssString.concat(
                ".general-session-catalog-remove-schedule-btn {",
                "float: right;",
                `background: ${config.catalogConfig.buttonConfig.removeScheduleButtonBackground};`,
                "padding: 8px;",
                "border-radius: 15px 0px 0px 0px;",
                "font-size: 20px;",
                `color: ${config.catalogConfig.buttonConfig.removeScheduleButtonColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.removeScheduleButtonStyle};`,
                "}"
            );

            cssString = cssString.concat(
                ".capacity-full {",
                "text-align: right;",
                "font-size: 18px;",
                `color: ${config.catalogConfig.buttonConfig.capacityFullColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.capacityFullFontStyle};`,
                "}"
            );

            cssString = cssString.concat(
                `.general-session-catalog-header-region-label {`,
                "position: absolute;",
                `border: 10px solid ${config.catalogConfig.header.regionConfig.background};`,
                "border-radius: 20px;",
                `top: ${top};`,
                `right: ${right};`,
                "cursor: default;",
                "float: right;",
                "padding: 4px 14px;",
                `font-size: ${config.catalogConfig.buttonConfig.regFontSize}px;`,
                `color: ${config.catalogConfig.buttonConfig.regColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.regFontStyle};`,
                "}"
            );
        }

        cssString = cssString.concat(
            `.general-session-catalog-button-registered {`,
            `background: ${config.catalogConfig.buttonConfig.regBackground};`,
            "border-radius: 20px;",
            "padding: 4px 14px;",
            `font-size: 10px;`,
            `color: ${config.catalogConfig.buttonConfig.regColor};`,
            `text-decoration: ${config.catalogConfig.buttonConfig.regFontStyle};`,
            `font-weight: ${config.catalogConfig.buttonConfig.regFontStyle};`,
            `font-style: ${config.catalogConfig.buttonConfig.regFontStyle};`,
            "}"
        );

        cssString = cssString.concat(
            ".footer-body-remaining-perc {",
            "font-size: 18px;",
            `color: ${config.catalogConfig.buttonConfig.fillingFastColor};`,
            `text-decoration: ${config.catalogConfig.buttonConfig.fillingFastFontStyle};`,
            `font-weight: ${config.catalogConfig.buttonConfig.fillingFastFontStyle};`,
            `font-style: ${config.catalogConfig.buttonConfig.fillingFastFontStyle};`,
            "}"
        );
        
        if(this.catalogLayoutConfig.generalStyle && this.catalogLayoutConfig.generalStyle == 'card') {
            cssString = cssString.concat(
                ".general-session-catalog-button-wait-card {",
                "position: absolute;",
                "border-radius: 20px;",
                `top: -8px;`,
                `right: -11px;`,
                "cursor: default;",
                "float: right;",
                `background: ${config.catalogConfig.buttonConfig.waitBackground};`,
                "padding: 4px 14px;",
                `font-size: ${config.catalogConfig.buttonConfig.waitFontSize}px;`,
                `color: ${config.catalogConfig.buttonConfig.waitColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                "}"
            );

        } else {
            cssString = cssString.concat(
                ".general-session-catalog-button-wait {",
                "position: absolute;",
                `border: 4px solid ${config.catalogConfig.header.regionConfig.background};`,
                "border-radius: 20px;",
                `top: ${top};`,
                `right: ${right};`,
                "cursor: default;",
                "float: right;",
                `background: ${config.catalogConfig.buttonConfig.waitBackground};`,
                "padding: 4px 20px;",
                `font-size: ${config.catalogConfig.buttonConfig.waitFontSize}px;`,
                `color: ${config.catalogConfig.buttonConfig.waitColor};`,
                `text-decoration: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                `font-weight: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                `font-style: ${config.catalogConfig.buttonConfig.waitFontStyle};`,
                "}"
            );
        }

        

        // cart processed confirmation popup wait icon
        cssString = cssString.concat(
            ".panel-wait-icon {",
            `color: ${config.catalogConfig.buttonConfig.waitBackground};`,
            "padding-right: 5px;}"
        );

        return cssString;
    }

    private createStyleStr(config, classPrefix, className): string {
        let cssString = "";

        cssString = cssString.concat(
            `.${classPrefix}-catalog-${className}-region { `,
            `margin: ${config.catalogConfig[`${className}`].regionConfig.margin};`,
            `padding: ${config.catalogConfig[`${className}`].regionConfig.padding};`,
            `background: ${config.catalogConfig[`${className}`].regionConfig.background};`,
            `border-radius: ${config.catalogConfig[`${className}`].regionConfig.corner};`,
            "}"
        );
        let buttonConfig = JSON.parse(this.configs[`${this.configTypes.LOGIN_POPUP}`].config);
        cssString = cssString.concat(
            `.${classPrefix}-catalog-${className}-region:hover { `,
            `border: 1px solid ${buttonConfig.footer.button.primary.background};`,
            `-webkit-box-shadow: 0 10px 6px -6px ${buttonConfig.footer.button.primary.background};`,
            `-moz-box-shadow: 0 10px 6px -6px ${buttonConfig.footer.button.primary.background};`,
            `box-shadow: 0 10px 6px -6px ${buttonConfig.footer.button.primary.background};`,
            "}"
        );

        cssString = cssString.concat(
            `.ddf-button { `,
            `background: ${buttonConfig.footer.button.primary.background};`,
            `border:none;`,
            `color:#FBFBFB;`,
            `cursor: pointer;`,
            "}"
        );
        return cssString;
    }

    private createTextStyleStr(config, classPrefix, className): string {
        let cssString = "";

        cssString = cssString.concat(
            `.${classPrefix}-catalog-${className}-text {`,
            `background: ${config.catalogConfig[`${className}`].textConfig.background};`,
            `width: ${
                config.layout != "l_noimage" && config.layout != "l_banner"
                    ? "calc(98% - " + config.catalogConfig[`${className}`].imageConfig.width + ")"
                    : "100%"
            };`,
            `color: ${config.catalogConfig[`${className}`].textConfig.textColor};`,
            "}"
        );

        return cssString;
    }

    private createImageCss(config, classPrefix, className): string {
        let cssString = "";

        if (config.layout != "l_noimage" && config.layout != "l_banner") {
            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-container {`,
                `height: ${config.catalogConfig[`${className}`].imageConfig.height};`,
                `width: ${config.catalogConfig[`${className}`].imageConfig.width};`,
                `background: ${config.catalogConfig[`${className}`].imageConfig.background};`,
                `margin: ${config.catalogConfig[`${className}`].imageConfig.margin};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig[`${className}`].imageConfig.height : "0px"
                };`,
                "}"
            );

            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-img {`,
                `height: ${config.catalogConfig[`${className}`].imageConfig.height};`,
                `width: ${config.catalogConfig[`${className}`].imageConfig.width};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig[`${className}`].imageConfig.height : "0px"
                };`,
                `${
                    config.catalogConfig[`${className}`].imageConfig.background != null &&
                    config.catalogConfig[`${className}`].imageConfig.background.trim().length != 0
                        ? "-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); opacity: 0.80;-moz-opacity: 80%;-webkit-opacity: 80%;"
                        : ""
                }`,
                "}"
            );
        } else if (config.layout === "l_banner") {
            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-img {`,
                `height: calc(100% - 2 * ${config.catalogConfig[`${className}`].imageConfig.margin});`,
                `width: calc(100% - 2 * ${config.catalogConfig[`${className}`].imageConfig.margin});`,
                `margin: ${config.catalogConfig[`${className}`].imageConfig.margin};` + "}"
            );
        }

        return cssString;
    }

    private createCssSpeaker({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        // speaker-catalog-body
        cssString = cssString.concat(
            ".speaker-catalog-body-region {",
            `margin: ${config.catalogConfig.body.regionConfig.margin};`,
            `padding: ${config.catalogConfig.body.regionConfig.padding};`,
            `background: ${config.catalogConfig.body.regionConfig.background};`,
            `border-radius: ${config.catalogConfig.body.regionConfig.corner};`,
            "}"
        );

        // speaker-header-label
        cssString = cssString.concat(
            ".speaker-header-label {",
            `color: ${config.labelConfig.fontColor};`,
            `text-decoration: ${config.labelConfig.fontStyle};`,
            `font-weight: ${config.labelConfig.fontStyle};`,
            `font-style: ${config.labelConfig.fontStyle};`,
            `margin: ${config.catalogConfig.body.regionConfig.margin};`,
            `padding: ${config.catalogConfig.body.regionConfig.padding};`,
            `font-size: ${config.labelConfig.fontSize}px;`,
            "}"
        );

        // bodyImgStyle
        cssString = cssString.concat(this.createImageCss(config, "speaker", "body"));

        // textstyle
        cssString = cssString.concat(this.createTextStyleStr(config, "speaker", "body"));

        return cssString;
    }

    private createCssFilter({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        // filter-header-section
        cssString = cssString.concat(
            ".filter-header-section {",
            `background-color: ${config.header.backgroundColor};`,
            `font-size: ${config.header.fontSize}px;`,
            `color: ${config.header.fontColor};`,
            "}"
        );

        // filter-header-label
        cssString = cssString.concat(
            ".filter-header-label {",
            `font-style: ${config.header.fontStyle};`,
            `text-decoration: ${config.header.fontStyle};`,
            `font-weight: ${config.header.fontStyle};`,
            `font-size: ${config.header.fontSize}px;`,
            `color: ${config.header.fontColor};`,
            "}"
        );

        // clear-filter
        cssString = cssString.concat(
            ".clear-filter {",
            `font-style: ${config.header.fontStyle};`,
            `text-decoration: ${config.header.fontStyle};`,
            `font-weight: ${config.header.fontStyle};`,
            `font-size: ${config.header.fontSize}px;`,
            `color: ${config.header.fontColor};`,
            "}"
        );

        // filter-body-section
        cssString = cssString.concat(
            ".filter-body-section {",
            `background-color: ${config.body.backgroundColor};`,
            `font-style: ${config.body.fontStyle};`,
            `text-decoration: ${config.body.fontStyle};`,
            `font-weight: ${config.body.fontStyle};`,
            `font-size: ${config.body.fontSize}px;`,
            `color: ${config.body.fontColor};`,
            `height: ${this.catalogLayoutConfig.filterPlacement == "slider" ? "calc(100% - 58px)" : ""};`,
            "}"
        );

        // filter-header-background
        cssString = cssString.concat(
            ".active-filter-bar .filter-header-background {",
            `border-color: ${config.header.backgroundColor};`,
            "}"
        );

        // attendee-container
        // cssString = cssString.concat(
        //     ".attendee-container {",
        //     `padding-left: ${this.catalogLayoutConfig.filterPlacement == "left" ? "0" : "150px"};`,
        //     `padding-right: 150px;`,
        //     "}"
        // );

        // Attendee container with media query worked well with large screens and small one also
        cssString = cssString.concat(
            ".attendee-container {",
                "padding-left: 0 !important;",
                "padding-right: 0 !important;",
            "}",
            "@media (min-width: 768px) {",
            ".attendee-container {",
                `padding-left: ${this.catalogLayoutConfig.filterPlacement === "left" ? "0" : "150px"} !important;`,
                "padding-right: 150px !important;",
            "}",
            "}"
        );

        // filter-slider-toggle
        cssString = cssString.concat(
            ".sidebar.floating .filter-slider-toggle {",
            `background-color: ${config.header.backgroundColor};`,
            `color: ${config.header.fontColor};`,
            "}"
        );

        return cssString;
    }

    private createCssMySession({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        if (config.hasOwnProperty("my_schedule")) {
            // my-session-catalog-header
        cssString = cssString.concat(
            ".session-instances.floating .session-instances-header-background, ",
            ".my-schedule.floating .my-schedule-header-background {",
            `background: ${config.my_schedule.my_schedule_header.background};`,
            "}"
        );

        // myschedule.header.label
        cssString = cssString.concat(".session-instances-header-label, .my-schedule-header-label {",
            `color: ${config.my_schedule.my_schedule_header.label_color};`,
            `font-style: ${config.my_schedule.my_schedule_header.fontStyle};`,
            `text-decoration: ${config.my_schedule.my_schedule_header.fontStyle};`,
            `font-weight: ${config.my_schedule.my_schedule_header.fontStyle != "bold" ? "normal" : config.my_schedule.my_schedule_header.fontStyle};`,
            "}");

        // myscheduleConfig.drawer_button
        cssString = cssString.concat(
            ".my-schedule.floating .my-schedule-drawer {",
            `background-color: ${config.my_schedule.my_schedule_header.background};`,
            `color: ${config.my_schedule.my_schedule_drawer_button.color};`,
            `border-color: ${config.my_schedule.my_schedule_drawer_button.color};`,
            "}"
        );

        // mysessionConfig.button.primary
        cssString = cssString.concat(
            ".my-schedule-button-primary {",
            `background-color: ${config.my_schedule.my_schedule_header.background};`,
            `color: ${config.my_schedule.my_schedule_header.label_color};`,
            "}"
        );
        }

        // my-session-catalog-header
        cssString = cssString.concat(
            ".my-session-catalog-header {",
            `margin: ${config.catalogConfig.header.regionConfig.margin};`,
            `padding: ${config.catalogConfig.header.regionConfig.padding};`,
            `background: ${config.catalogConfig.header.textConfig.background};`,
            `border-radius: ${config.catalogConfig.header.regionConfig.corner};`,
            `color: ${config.catalogConfig.header.textConfig.textColor};`,
            "position: relative;",
            "}"
        );

        // my session header background
        cssString = cssString.concat(
            ".attendee-cart.floating .my-session-header-background, ",
            ".my-schedule.floating .my-session-header-background, ",
            ".session-instances.floating .my-session-header-background { ",
            `background: ${config.header.background};`,
            "}"
        );

        // cart processed confirmation popup header
        cssString = cssString.concat(
            ".cart-processed .ui-pnotify-title {",
            `background: ${config.header.background};`,
            `color: ${config.header.label_color} !important;`,
            "}"
        );

        // cart processed confirmation popup buttons
        cssString = cssString.concat(
            ".cart-processed .ui-pnotify-action-button {",
            `background: ${config.button.primary.background} !important;`,
            `color: ${config.button.primary.color} !important;`,
            "}"
        );

        cssString = cssString.concat(
            ".cart-processed .cart-popup-cancel {",
            `background: ${config.button.secondary.background} !important;`,
            `color: ${config.button.secondary.color} !important;`,
            "}"
        );

        // calendar icon
        cssString = cssString.concat(
            ".calendar-icon {",
            `color: ${config.drawer_button.color};`,
            `font-style: ${config.header.fontStyle};`,
            `text-decoration: ${config.header.fontStyle};`,
            `font-weight: ${config.header.fontStyle};`,
            "}"
        );

        // cart-icon
        cssString = cssString.concat(".cart-icon {", `color: ${config.drawer_button.color};`, "}");

        // myschedule.header.label
        // cssString = cssString.concat(".my-schedule-header-label {", `color: ${config.header.label_color};`, "}");

        // my-session-header-label
        cssString = cssString.concat(
            ".my-session-header-label {",
            `color: ${config.header.label_color};`,
            `font-style: ${config.header.fontStyle};`,
            `text-decoration: ${config.header.fontStyle};`,
            `font-weight: ${config.header.fontStyle != "bold" ? "normal" : config.header.fontStyle};`,
            "}"
        );

        // mysessionConfig.button.primary
        cssString = cssString.concat(
            ".my-session-button-primary {",
            `background-color: ${config.button.primary.background};`,
            `color: ${config.button.primary.color};`,
            "}"
        );

        // mysessionConfig.button.secondary
        cssString = cssString.concat(
            ".my-session-button-secondary {",
            `background-color: ${config.button.secondary.background};`,
            `color: ${config.button.secondary.color};`,
            "}"
        );

        // mysessionConfig.drawer_button
        cssString = cssString.concat(
            ".my-schedule.floating .my-session-drawer, .attendee-cart.floating .my-session-drawer {",
            `background-color: ${config.drawer_button.background};`,
            `color: ${config.drawer_button.color};`,
            `border-color: ${config.drawer_button.color};`,
            "}"
        );

        // my-session-tab-cart-active
        cssString = cssString.concat(
            ".attendee-cart.floating .cart-body .cart-container .cart-tabs .my-session-tab-cart-active {",
            `color: ${config.tabConfig.activeLabelColor};`,
            `margin: 5px;`,
            `border-bottom-color: ${config.tabConfig.activeBorderColor};`,
            `border-bottom-style: ${config.tabConfig.borderStyle};`,
            "}"
        );

        // my-session-tab-cart-inactive
        cssString = cssString.concat(
            ".attendee-cart.floating .cart-body .cart-container .cart-tabs .my-session-tab-cart-inactive {",
            `color: ${config.tabConfig.inactiveLabelColor};`,
            `margin: 5px;`,
            `border-bottom-color: ${config.tabConfig.inactiveBorderColor};`,
            `border-bottom-style: ${config.tabConfig.borderStyle};`,
            "}"
        );

        return cssString;
    }

    private createCssLoginPopup({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        // adding login header
        cssString = cssString.concat(".login-header-background {", `background: ${config.header.background};`, "}");

        // adding login header label
        cssString = cssString.concat(
            ".login-header-label {",
            `color: ${config.header.label_color};`,
            `font-style: ${config.header.fontStyle};`,
            `text-decoration: ${config.header.fontStyle};`,
            `font-weight: ${config.header.fontStyle != "bold" ? "normal" : config.header.fontStyle};`,
            "}"
        );

        // secondary button
        cssString = cssString.concat(
            ".login-footer-button-secondary {",
            `background-color: ${config.footer.button.secondary.background};`,
            `color: ${config.footer.button.secondary.color};`,
            "}",
            ".login-footer-button-secondary:hover {",
            `background-color: ${config.footer.button.secondary.background};`,
            "}"
        );

        // primary button
        cssString = cssString.concat(
            ".login-footer-button-primary {",
            `background-color: ${config.footer.button.primary.background};`,
            `color: ${config.footer.button.primary.color};`,
            "}",
            ".login-footer-button-primary:hover {",
            `background-color: ${config.footer.button.primary.background};`,
            "}"
        );

        // SCM-55849 -- Design session-expired silent configurable popup display with UI
        // adding session-expired header
        if(!config.sessionExpiredConfig) {
            config.sessionExpiredConfig = this.loginConfig.sessionExpiredConfig;
        }
        
        cssString = cssString.concat(
            ".session-expired-header-background {", 
            `background: ${config.sessionExpiredConfig.header.background};`, 
            "}");

        // adding session-expired header label
        cssString = cssString.concat(
            ".session-expired-header-label {",
            `color: ${config.sessionExpiredConfig.header.label_color};`,
            `font-style: ${config.sessionExpiredConfig.header.fontStyle};`,
            `text-decoration: ${config.sessionExpiredConfig.header.fontStyle};`,
            `font-weight: ${config.sessionExpiredConfig.header.fontStyle != "bold" ? "normal" : config.sessionExpiredConfig.header.fontStyle};`,
            "}"
        );

        // Add session-expired primary button CSS styling
        cssString = cssString.concat(
            ".session-expired-footer-button-primary {",
            `background-color: ${config.sessionExpiredConfig.footer.button.primary.background};`,
            `color: ${config.sessionExpiredConfig.footer.button.primary.color};`,
            "}",
            ".session-expired-footer-button-primary:hover {",
            `background-color: ${config.sessionExpiredConfig.footer.button.primary.background};`,
            "}"
        );

        return cssString;
    }

    private createCssTabs({ config }): string {
        config = JSON.parse(config);
        let cssString = "";
        cssString = cssString.concat(
            ".tab-element-custom { ",
            `color: ${config.inactiveLabelColor}; `,
            `border-bottom-color: ${config.inactiveBorderColor}; `,
            `border-bottom-style: ${config.borderStyle}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom.active { ",
            `color: ${config.activeLabelColor}; `,
            `border-bottom-color: ${config.activeBorderColor}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom-tab { ",
            `box-shadow: 0 0 3px ${config.inactiveBorderColor}; `,
            "margin: 5px; ",
            `background: ${config.inactiveBorderColor}; `,
            "border-bottom: 0px; } ",
            ".tab-element-custom-tab.active { ",
            `box-shadow: 0 0 3px ${config.activeBorderColor}; `,
            `background: ${config.activeBorderColor}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom-underline { ",
            "box-shadow: none; ",
            "margin: 5px; ",
            "background: none; ",
            "border-bottom: ''; }",
            ".tab-element-custom-underline.active { ",
            "background: none; " + "} "
        );

        return cssString;
    }
}
